/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Band_TitleInputs */

const en_shop_band_title = /** @type {(inputs: Shop_Band_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the shop.`)
};

const pl_shop_band_title = /** @type {(inputs: Shop_Band_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ze sklepu.`)
};

/**
* | output |
* | --- |
* | "From the shop." |
*
* @param {Shop_Band_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_band_title = /** @type {((inputs?: Shop_Band_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Band_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_band_title(inputs)
	return en_shop_band_title(inputs)
});